import tokenData from '../../design-tokens/base-tokens.json';
import { darken, lighten } from '@mui/material/styles';
import MinusCircleOutline from 'mdi-material-ui/MinusCircleOutline';
export const MuiDataGrid = {
    defaultProps: {
        slots: {
            filterPanelDeleteIcon: MinusCircleOutline
        },
        slotProps: {
            baseTextField: {
                variant: 'outlined',
                size: 'small'
            },
            filterPanel: {
                filterFormProps: {
                    logicOperatorInputProps: {
                        variant: 'outlined'
                    },
                    columnInputProps: {
                        variant: 'outlined'
                    },
                    operatorInputProps: {
                        variant: 'outlined'
                    },
                    valueInputProps: {
                        InputComponentProps: {
                            limitTags: 1,
                            variant: 'outlined',
                            InputLabelProps: {
                                shrink: false
                            }
                        }
                    }
                }
            }
        },
        checkboxSelectionVisibleOnly: true,
        columnHeaderHeight: 32
    },
    styleOverrides: {
        root: ({ theme }) => ({
            ...theme.typography.body1,
            input: {
                ...theme.typography.body1,
            },
            overflow: 'hidden',
            '& .MuiDataGrid-main': {
                background: '#fff'
            },
            '&.MuiDataGrid-withBorderColor, .MuiDataGrid-withBorderColor': {
                borderColor: tokenData.tokens.palette.grey.grey300
            },
            '& .MuiDataGrid-columnHeaders': {
                borderRadius: '0 !important',
                '& .MuiIconButton-root': {
                    fontSize: 18
                }
            },
            '& [class*="MuiDataGrid-toolbarQuickFilter"]': {
                marginBottom: 0
            },
            '& .MuiDataGrid-columnHeader': {
                borderRadius: '0 !important',
                '&:hover, &:focus': {},
                '& .MuiIconButton-root': {
                    '&:hover': {
                        '& .MuiSvgIcon-root': {
                            opacity: 1
                        }
                    }
                },
                '& .MuiDataGrid-iconButtonContainer, .MuiDataGrid-menuIconButton': {
                    '& .MuiSvgIcon-root': {
                        opacity: 1,
                        '&:hover': {}
                    }
                },
                '&:not(.MuiDataGrid-columnHeader--sorted)': {
                    '&:hover': {
                        '& .MuiDataGrid-sortIcon': {
                            opacity: 1,
                            '&:hover': {
                                opacity: '1 !important'
                            }
                        }
                    }
                }
            },
            '& .MuiDataGrid-detailPanelToggleCell': {
                '&.Mui-disabled': {
                    display: 'none'
                }
            },
            '& .MuiDataGrid-iconButtonContainer': {},
            '& .MuiInputBase-root.MuiOutlinedInput-root': {
                background: '#fff'
            },
            '& .MuiDataGrid-iconSeparator': {},
            '& .MuiDataGrid-pinnedColumnHeaders': {
                borderRadius: '0 !important'
            },
            '& .MuiSelect-select': {
                '& .MuiSvgIcon-fontSizeSmall, .MuiSvgIcon-fontSizeMedium ': {
                    fontSize: 20
                }
            },
            '& .MuiTablePagination-selectLabel': {
                margin: 0
            },
            '& .MuiDataGrid-menuIcon': {
                marginRight: 0
            },
            '& .MuiDataGrid-menuIconButton .MuiSvgIcon-root': {
                fontSize: 'inherit'
            },
            '& .MuiDataGrid-row': {
                '&.Mui-selected': {
                    background: '#F5FBFF',
                    '& .Mui-hovered': {
                        background: '#EBF6FE'
                    },
                    '&:hover, &.Mui-hovered': {
                        background: '#EBF6FE'
                    }
                },
                '&.Mui-hovered': {
                    backgroundColor: tokenData.tokens.palette.background.linen
                },
                '&.row-unread': {
                    fontWeight: 600
                }
            },
            '& .MuiDataGrid-row.Mui-selected': {
                '&:hover': {}
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 700,
                marginRight: 8
            },
            '& .MuiDataGrid-row:not(.MuiDataGrid-row--editing):not(.Mui-selected):hover': {
                backgroundColor: tokenData.tokens.palette.background.linen
            },
            '& [class*=MuiTablePagination-select], .MuiTablePagination-input': {
                marginRight: 8
            },
            '& .MuiDataGrid-editInputCell input': {
                padding: 0
            },
            '& .MuiDataGrid-cell': {
                flex: 2,
                padding: '0.5rem',
                alignItems: 'baseline',
                '&:before': {
                    flex: 1
                },
                '&.MuiDataGrid-cell--editing': {
                    padding: '0.5rem'
                },
                '& .MuiFormControl-root': {
                    width: '100%'
                },
                '& a': {
                    wordBreak: 'break-word'
                },
                '& .MuiBadge-root': {
                    padding: 0
                },
                '& .MuiBadge-badge': {
                    position: 'relative'
                },
                '& .MuiBadge-standard:not(.MuiBadge-invisible)': {
                    transform: 'scale(1) translate(0, 0)'
                },
                '& .MuiBadge-invisible': {
                    transform: 'scale(0) translate(0, 0)'
                },
                '& .MuiBadge-dot': {
                    marginTop: 6
                }
            },
            '& .MuiDataGrid-editBooleanCell': {
                flex: 2,
                justifyContent: 'flex-start',
                alignItems: 'baseline'
            },
            '& .MuiDataGrid-cellContent': {
                width: '100%'
            },
            '& .MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader:focus': {
                outline: '2px solid #000',
                outlineOffset: '-2px'
            },
            '& .MuiDataGrid-booleanCell': {
                alignSelf: 'center'
            },
            '& .MuiSelect-root': {
                margin: '0 1rem'
            },
            '& .MuiInputBase-root:not([class*=MuiSelect-root])': {
                '&.Mui-error': {
                    borderColor: tokenData.tokens.palette.red.red600,
                    boxShadow: '0px 0px 0px 2px rgba(196, 32, 20, 0.5)',
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${tokenData.tokens.palette.red.red600}`
                    }
                }
            },
            '& .MuiFormControlLabel-root, .MuiFormGroup-root': {
                marginLeft: 0
            },
            '& dt': {
                padding: 0
            },
            '& dd': {
                marginLeft: 0,
                padding: 0
            },
            '& .MuiInputBase-root .MuiTablePagination-select': {
                fontWeight: 700
            },
            '& .MuiDataGrid-toolbarContainer': {
                padding: theme.spacing(1) === '2px' ? theme.spacing(4, 6, 2, 6) : theme.spacing(3, 3, 3, 3),
                borderBottom: `1px solid ${tokenData.tokens.palette.grey.grey300}`,
                rowGap: 6,
                '& .MuiTablePagination-displayedRows': {
                    margin: 0
                }
            },
            '& .MuiButton-outlined': {
                '&.Oclc-GridToolbarButton': {
                    padding: `calc(${theme.spacing(2)} - 1px)`,
                    minWidth: 0,
                    '& .MuiButton-startIcon': { margin: '0 !important' }
                },
            },
            '& .MuiTablePagination-toolbar': {
                minHeight: 0,
                paddingTop: theme.spacing(1),
                paddingRight: 0,
                paddingBottom: theme.spacing(1),
            },
            '& .MuiDataGrid-footerContainer': {
                minHeight: 36,
                '& .MuiTablePagination-root': {
                    paddingRight: theme.spacing(6)
                }
            },
            '& .MuiDataGrid-row--detailPanelExpanded': {
                '& .MuiDataGrid-cell[data-colindex="0"]:first-of-type': {
                    position: 'relative',
                    '&:before': {
                        content: '" "',
                        position: 'absolute',
                        bottom: '-1px',
                        left: 0,
                        width: 4,
                        height: 'calc(100% + 1px)',
                        background: `${theme.palette.primary.main}`
                    }
                }
            },
            '& .MuiDataGrid-detailPanel': {
                borderLeft: `4px solid ${theme.palette.primary.main}`,
                borderBottom: `1px solid ${tokenData.tokens.palette.grey.grey300}`
            },
            '& .MuiDataGrid-actionsCell': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18
                }
            },
            '&.OclcDataGrid-striped-alt': {
                '& .MuiDataGrid-row:nth-of-type(odd):not(.Mui-selected)': {
                    backgroundColor: lighten(tokenData.tokens.palette.grey.grey100, 0.25),
                    '&:not(.MuiDataGrid-row--editing):hover': {
                        backgroundColor: darken(tokenData.tokens.palette.grey.grey100, 0.025)
                    }
                }
            },
            '&.OclcDataGrid-responsive': {
                '& .MuiDataGrid-row:not(.MuiDataGrid-row--editing):not(.Mui-selected):hover': {
                    backgroundColor: darken(tokenData.tokens.palette.grey.grey100, 0.025)
                },
                '& [class*=MuiTablePagination-select]': {
                    marginLeft: 4
                },
                '& .MuiDataGrid-editInputCell input': {
                    padding: 0
                },
                '& .MuiDataGrid-cell': {
                    flex: 2,
                    padding: '0.5rem',
                    alignItems: 'baseline',
                    '&:before': {
                        flex: 1
                    },
                    '&.MuiDataGrid-cell--editing': {
                        padding: '0.5rem'
                    },
                    '& .MuiFormControl-root': {
                        width: '100%'
                    },
                    '& a': {
                        wordBreak: 'break-word'
                    }
                },
                '& .MuiDataGrid-editBooleanCell': {
                    flex: 2,
                    justifyContent: 'flex-start',
                    alignItems: 'baseline'
                },
                '& .MuiDataGrid-cellContent': {
                    width: '100%'
                },
                '& .MuiDataGrid-booleanCell': {
                    alignSelf: 'center'
                },
                '& .MuiSelect-root': {
                    margin: '0 1rem'
                },
                '& .MuiInputBase-root:not([class*=MuiSelect-root])': {
                    '&.Mui-error': {
                        borderColor: tokenData.tokens.palette.red.red600,
                        boxShadow: '0px 0px 0px 2px rgba(196, 32, 20, 0.5)',
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: `1px solid ${tokenData.tokens.palette.red.red600}`
                        }
                    }
                },
                '& .MuiFormControlLabel-root, .MuiFormGroup-root': {
                    marginLeft: 0
                },
                '& dt': {
                    padding: 0
                },
                '& dd': {
                    marginLeft: 0,
                    padding: 0
                },
                [theme.breakpoints.down('sm')]: {
                    display: 'block',
                    maxWidth: 'none !important',
                    width: '100%',
                    flexWrap: 'wrap !important',
                    '& .MuiDataGrid-row, .MuiDataGrid-cell, .MuiDataGrid-virtualScrollerRenderZone': {
                        display: 'block',
                        maxWidth: 'none !important',
                        width: '100%',
                        flexWrap: 'wrap !important'
                    },
                    '& .MuiDataGrid-cell:not([data-field="__check__"])': {
                        display: 'flex',
                        justifyContent: 'left',
                        flexWrap: 'wrap'
                    },
                    '& .MuiFormControl-root': {
                        flex: 2
                    },
                    '& .MuiDataGrid-columnHeader': {
                        minWidth: '0 !important',
                        width: 'auto !important'
                    },
                    '& .MuiDataGrid-row': {
                        marginBottom: '1rem'
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        display: 'none',
                        position: 'relative',
                        maxHeight: 'none !important'
                    },
                    '& [class*="MuiDataGrid-columnHeaderRow"]': {
                        flexWrap: 'wrap !important'
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                        maxWidth: '100%'
                    },
                    '& .MuiDataGrid-virtualScroller': {
                        marginTop: '0 !important'
                    }
                }
            }
        }),
        panelContent: ({ theme }) => ({
            padding: 16,
            '& .MuiDataGrid-filterForm': {
                '& .MuiFormControl-root': {
                    '& .MuiFormLabel-root': {
                        color: tokenData.tokens.palette.text.text300,
                        fontWeight: 600,
                        ...theme.typography.label
                    },
                    'label + .MuiInputBase-root': {
                        marginTop: 8
                    }
                }
            },
            '& .MuiTextField-root': {
                '& .MuiInputLabel-root': {
                    marginBottom: 0
                }
            },
            '& .MuiAutocomplete-root': {
                '& .MuiOutlinedInput-notchedOutline': {
                    '& legend': {
                        '& span': {
                            display: 'none'
                        }
                    }
                }
            },
            '& :not(.MuiDataGrid-filterForm:first-of-type)': {
                '& .MuiDataGrid-filterFormColumnInput': {
                    '& .MuiFormLabel-root': {
                        clip: 'rect(0 0 0 0)',
                        clipPath: 'inset(50%)',
                        height: 1,
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: 1
                    }
                },
                '& .MuiDataGrid-filterFormOperatorInput': {
                    '& .MuiFormLabel-root': {
                        clip: 'rect(0 0 0 0)',
                        clipPath: 'inset(50%)',
                        height: 1,
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: 1
                    }
                },
                '& .MuiDataGrid-filterFormValueInput': {
                    '& .MuiFormLabel-root': {
                        clip: 'rect(0 0 0 0)',
                        clipPath: 'inset(50%)',
                        height: 1,
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: 1
                    }
                }
            }
        }),
        detailPanelExpanded: {
            borderLeft: '1px solid red'
        },
        detailPanel: {
            padding: 20,
            paddingLeft: 108
        },
        filterForm: {
            padding: 0,
            columnGap: 8,
            alignItems: 'end',
            '& .MuiDataGrid-filterFormDeleteIcon': {
                marginRight: 0,
                '& .MuiIconButton-root': {
                    color: tokenData.tokens.palette.darkBlue.darkBlue600,
                    '& .MuiSvgIcon-root': {
                        fontSize: 20
                    }
                }
            },
            '& .MuiDataGrid-filterFormLogicOperatorInput': {
                marginRight: 0,
                '& .MuiInputBase-root': {
                    '& .MuiNativeSelect-select': {
                        textTransform: 'uppercase',
                        '&.Mui-disabled': {
                            color: tokenData.tokens.palette.text.text200,
                            WebkitTextFillColor: tokenData.tokens.palette.text.text200,
                            backgroundColor: tokenData.tokens.palette.background.white
                        }
                    },
                    '&.Mui-disabled': {
                        '> fieldset': {
                            border: 'none'
                        },
                        '& .MuiSvgIcon-root': {
                            display: 'none'
                        }
                    }
                }
            },
            '& .MuiDataGrid-filterFormValueInput': {
                minWidth: '275px',
                '& .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root .MuiChip-root': {
                    maxWidth: '120px'
                },
                '> div': {
                    '& .MuiFormControl-root': {
                        width: '100%',
                        '& .MuiOutlinedInput-notchedOutline': {
                            '& legend': {
                                '& span': {
                                    display: 'none'
                                }
                            }
                        }
                    }
                }
            }
        },
        columnsPanel: {
            padding: 0
        },
        columnsPanelRow: {
            '&:not(:last-of-type)': {
                marginBottom: 12
            }
        },
        panelHeader: {
            padding: 16,
            borderBottom: `1px solid ${tokenData.tokens.palette.grey.grey300}`
        },
        panelFooter: {
            padding: '8px',
            backgroundColor: tokenData.tokens.palette.background.linen,
            borderBottomLeftRadius: 6,
            borderBottomRightRadius: 6,
            '& .MuiButtonBase-root': {
                fontSize: '0.875rem',
                fontWeight: 600,
                '& .MuiButton-startIcon': {
                    marginRight: 4,
                    '& .MuiSvgIcon-root': {
                        fontSize: 16
                    }
                }
            }
        }
    }
};
export default MuiDataGrid;
